// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
 .bg-light {
  background-color: #e9ecef !important;
}

.section-height-75 {
  min-height: 75vh;
}

.page-header {
  padding: 0;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  background-size: cover;
  background-position: 50%;
  background: #000;
  min-height: 100vh;
}

.card {
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
}
.card-style{
background: #292f36!important;
}
.card-descp{
color: #fff;
}

.mt-xl-5 {
  margin-top: 3rem !important;
}

.card .card-header {
  padding: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 0px solid rgba(0, 0, 0, .125);

}

.card-header:first-child {
  border-radius: 1rem 1rem 0 0;
}

.text-center {
  text-align: center !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.card .card-body {
  font-family: 'Open Sans', sans-serif;
  /* padding: 1.5rem; */
}

.card-body {
  flex: 1 1 auto;
  padding: 1rem 1rem;
}

label,
.form-label {
  font-size: 0.75rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #252f40;
  margin-left: 0.25rem;
}

.form-control {
  display: block;
  width: 100%;
  padding: 1rem 0.75rem;
  font-size: 0.975rem;
  font-weight: 400;
  line-height: 1.4rem;
  color: #333;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d2d6da;
  appearance: none;
  border-radius: 0.2rem;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.form-switch {
  padding-left: 3rem;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.73em;
  margin-bottom: 0.125rem;
}

.form-switch .form-check-input:checked {
  border-color: rgba(58, 65, 111, 0.95);
  background-color: rgba(58, 65, 111, 0.95);
}

.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: none;
}

.form-check-input:checked[type="checkbox"] {
  background-image: linear-gradient(310deg, #141727 0%, #3A416F 100%);
}

.form-switch .form-check-input {
  border: 1px solid #e9ecef;
  border-top-color: rgb(233, 236, 239);
  border-right-color: rgb(233, 236, 239);
  border-bottom-color: rgb(233, 236, 239);
  border-left-color: rgb(233, 236, 239);
  position: relative;
  background-color: rgba(58, 65, 111, 0.1);
  height: 1.25em;
}

.form-check-label,
.form-check-input[type="checkbox"] {
  cursor: pointer;
}

.form-switch .form-check-input {
  width: 2.5rem;
  margin-left: -3rem;
  background-image: none;
  background-position: left center;
  border-radius: 2.5rem;
  transition: background-color 0.25s ease, border-color 0.25s ease, background-position 0.15s ease-in-out, opacity 0.15s ease-out, box-shadow 0.15s ease-in-out;
}

.form-check-input:checked {
  background-color: transparent;
  border-color: transparent;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.73em;
}

.form-check-input {
  appearance: none;
}

a {
  letter-spacing: -0.025rem;
  color: #000;
}

.form-check-input {
  width: 1.23em;
  height: 1.23em;
  margin-top: 0.135em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: none;
  appearance: none;
  color-adjust: exact;
  transition: background-color 0.25s ease, border-color 0.25s ease, background-position 0.15s ease-in-out, opacity 0.15s ease-out, box-shadow 0.15s ease-in-out;
}

.form-check-input {
  color-adjust: exact;
}

.form-switch .form-check-input:checked::after {
  transform: translateX(21px);
}

.form-switch .form-check-input::after {
  transition: transform 0.25s ease-in-out, background-color 0.25s ease-in-out;
  content: "";
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  position: absolute;
  background-color: #fff;
  transform: translateX(1px);
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(20, 20, 20, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(20, 20, 20, 0.07);
  top: 1px;
}

.text-bold {
  font-weight: 600;
}

.text-decoration-none {
  text-decoration: none !important;
}

.bg-primary {
  background-color: #C22627 !important;
}

.me-xl-5 {
  margin-right: 3rem !important;
}

a:hover {
  color: #830866;
  text-decoration: none;
}

.me-xl-5 {
  margin-right: 3rem !important;
}

.mb-sm-0 {
  margin-bottom: 0 !important;
}

.container,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  max-width: 1320px;
}

.nav-footer .nav-link {
  font-size: .875rem;
}

.h2,
h2 {
  font-size: 1.25rem;
}

.btn-neutral {
  color: #7b2fe3;
}

.table td,
.table th {
  font-size: .8125rem;
  white-space: normal;
}

.pray_text {
  max-width: 450px;
}

.table-flush tbody tr:first-child td,
.table-flush tbody tr:first-child th {
  border-top: 0;
}

.card .table td,
.card .table th {
  padding-right: 1rem;
  padding-left: 1rem;
}

.custom-toggle {
  position: relative;
  display: inherit;
  display: inline-block;
  width: 52px;
  height: 1.5rem;
  margin: 0;
}

.custom-toggle input {
  display: none;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

.custom-toggle input:checked+.custom-toggle-slider {
  border: 1px solid #7b2fe3;
}

.custom-toggle-slider {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: pointer;
  border: 1px solid #ced4da;
  border-radius: 34px !important;
  background-color: transparent;
}

.avatar.rounded-circle img,
.rounded-circle {
  border-radius: 50% !important;
}

.custom-toggle input:checked+.custom-toggle-slider::before {
  transform: translateX(28px);
  background: #7b2fe3;
}

.custom-toggle-slider::before {
  position: absolute;
  bottom: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  content: '';
  transition: all .15s cubic-bezier(.68, -.55, .265, 1.55);
  border-radius: 50% !important;
  background-color: #e9ecef;
}

.custom-toggle input:checked+.custom-toggle-slider::after {
  right: auto;
  left: 0;
  content: attr(data-label-on);
  color: #7b2fe3;
}

.custom-toggle-slider::after {
  font-family: inherit;
  font-size: .75rem;
  font-weight: 600;
  line-height: 24px;
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  overflow: hidden;
  min-width: 1.66667rem;
  margin: 0 .21667rem;
  content: attr(data-label-off);
  transition: all .15s ease;
  text-align: center;
  color: #ced4da;
}

.form-control {
  padding: .6rem .75rem !important;
}

.form-control-label {
  font-size: .875rem;
  font-weight: 600;
  color: #2f3135;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin: 0;
  opacity: 0;
}

.custom-file-input {
  width: 60% !important;
  margin: 5px !important;
  opacity: 1 !important;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.custom-file-label {
  font-weight: 400;
  line-height: 1.5;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  left: 0;
  height: calc(1.5em + 1.25rem + 2px);
  padding: .625rem .75rem;
  color: #8898aa;
  border: 1px solid #dee2e6;
  border-radius: .25rem;
  background-color: #fff;
  box-shadow: 0 3px 2px rgba(233, 236, 239, .05);
}

.custom-file-input:lang(en)~.custom-file-label::after {
  content: 'Browse';
}

.custom-control-label::after {
  top: 0.5rem !important;
}

.custom-file-label::after {
  line-height: 1.5;
  position: absolute;
  z-index: 3;
  top: 0;
  right: 0;
  bottom: 0;
  display: block;
  height: calc(1.5em + 1.25rem);
  padding: .625rem .75rem;
  content: 'Browse';
  color: #8898aa;
  border-left: inherit;
  border-radius: 0 .25rem .25rem 0;
  background-color: #fff;
}

.pagination {
  margin: 15px auto 10px;
  padding-bottom: 2rem;
  justify-content: end;
}

.card-header h3 {
  font-size: 20px;
}

.pagination>.active>a {
  background-color: #C22627;
  border-color: #C22627;
  color: #fff;
}

.pagination>li>a {
  border: 1px solid #C22627;
  padding: 5px 10px;
  outline: none;
  cursor: pointer;
}

.pagination>.active>a,
.pagination>.active>span,
.pagination>.active>a:hover,
.pagination>.active>span:hover,
.pagination>.active>a:focus,
.pagination>.active>span:focus {
  background-color: #C22627;
  border-color: #C22627;
  outline: none;
}

.pagination>li>a,
.pagination>li>span {
  color: #47ccde
}

.pagination>li:first-child>a,
.pagination>li:first-child>span,
.pagination>li:last-child>a,
.pagination>li:last-child>span {
  border-radius: unset
}

.svg-inline--fa.fa-play.fa-w-14 {
  color: #04d611;
}

.loader_block {
  position: fixed;
  display: block;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100% !important;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.7);
}

.loader_block span {
  left: 50%;
  top: 50%;
  position: relative;
}

.hide-display {
  display: none;
}

.Toastify__toast {
  padding: 17px !important;
}

.doc_type {
  font-size: large;
  font-weight: bold;
}

.reject {
  color: red;
  font-weight: bold;
}

.approve {
  color: green;
  font-weight: bold;
}

.date-pickk {
  margin-bottom: 10px;
}

.date-pickk input,
.date-pickk>div {
  width: 100% !important;
}

.date-pickk input {
  color: #333;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d2d6da;
  appearance: none;
  border-radius: 0.2rem;
  padding: .6rem .75rem !important;
}

.display-end {
  display: flex;
  justify-content: end;
}

.contrcat-input {
  width: 100%!important;
  background: white!important;
  border: 1px solid #d2d6da!important;
  padding: .5rem .75rem!important;
  border-radius: 3px!important;
  font-size: 0.975rem!important;
  font-weight: 400!important;
  line-height: 1.4rem!important;
  color: #333!important;
}

.paginate-css {
  display: flex;
  justify-content: end;
}

.pagination>.active>a {
  background-color: #C22627;
  border-color: #C22627;
  color: #fff;
}

.pagination>li>a {
  border: 1px solid #adb5bd;
  padding: 8px 15px;
  outline: none;
  cursor: pointer;
  margin: 3px;
  text-transform: uppercase;
  border-radius: 5px;
}

.pagination>.active>a,
.pagination>.active>span,
.pagination>.active>a:hover,
.pagination>.active>span:hover,
.pagination>.active>a:focus,
.pagination>.active>span:focus {
  background-color: #565b60;
  border-color: #565b60;
  outline: none;

}

.pagination>li>a,
.pagination>li>span {
  color: #565b60;
}

.pagination>li:first-child>a,
.pagination>li:first-child>span,
.pagination>li:last-child>a,
.pagination>li:last-child>span {
  border-radius: 2px
}

.table-user .name {
  display: block;
  max-width: 150px;
  width: 100px;
}

.td-wrapper {
  background-color: 'lightblue';
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.table-user .nameee {
  display: block;
  max-width: 150px;
  width: 150px;

}

.table-user .name2 {
  display: block;
  max-width: 200px;
  width: 170px;
}

.date {
  width: 110px;
  display: block;
}

.date2 {
  width: 70px;
  display: block;
}

.address {
  display: block;
  max-width: 200px;
  width: 170px;
}

.name-letter {
  width: 50px;
  height: 50px;
  border-radius: 30px;
  background-color: #C22627;
  color: #fff;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 20px;
}

.address-column {
  width: 250px;
  word-wrap: break-word;
  /* background-color: #04d611; */
}

@media screen and (min-width: 1200px) {
  .large-address-column {
    width: 350px;
    /* background-color: #6200ea; */
  }
}

.mobile-sidebar-slide {
  position: absolute;
  top: 50px;
  left: 0;
  width: 250px;
  height: 100vh;
  background-color: #343a40; 
  z-index: 1000;
  animation: slideInLeft 0.3s ease forwards;
  color: white;
  padding: 1rem;
}

@keyframes slideInLeft {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}



.navbar-nav ul {
  list-style: none;
  padding-left: 0.5rem;
}
.navbar-nav .nav-item .nav-link.active {
  font-weight: bold;
}


.no-scrollbar {
  overflow-y: scroll;
}

/* Chrome, Edge, Safari */
.no-scrollbar::-webkit-scrollbar {
  width: 4px;          /* decrease width */
}

.no-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1; /* track color (optional) */
}

.no-scrollbar::-webkit-scrollbar-thumb {
  background: #888;    /* thumb color */
  border-radius: 10px;
}

.no-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Firefox */
.no-scrollbar {
  scrollbar-width: thin;  /* makes it thin */
  scrollbar-color: #888 #f1f1f1; /* thumb + track colors */
}

















`, "",{"version":3,"sources":["webpack://./src/css/mainstyle.css"],"names":[],"mappings":";CAIA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;AAC/C;AACA;AACA,6BAA6B;AAC7B;AACA;AACA,WAAW;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,4CAA4C;;AAE9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,sCAAsC;EACtC,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,qBAAqB;EACrB,6JAA6J;AAC/J;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EAGE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,6JAA6J;AAC/J;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2EAA2E;EAC3E,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,sHAAsH;EACtH,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,wDAAwD;EACxD,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,OAAO;EACP,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;EAGE,yGAAyG;AAC3G;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,OAAO;EACP,mCAAmC;EACnC,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,SAAS;EACT,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE;AACF;;AAEA;;;;EAIE;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,QAAQ;EACR,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;;AAEf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;;AAEd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE;IACE,YAAY;IACZ,+BAA+B;EACjC;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,yCAAyC;EACzC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;;;AAIA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,UAAU,WAAW,mBAAmB;AAC1C;;AAEA;EACE,mBAAmB,EAAE,2BAA2B;AAClD;;AAEA;EACE,gBAAgB,KAAK,gBAAgB;EACrC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,qBAAqB,GAAG,kBAAkB;EAC1C,6BAA6B,EAAE,yBAAyB;AAC1D","sourcesContent":["\r\n @import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');\r\n\r\n                \r\n.bg-light {\r\n  background-color: #e9ecef !important;\r\n}\r\n\r\n.section-height-75 {\r\n  min-height: 75vh;\r\n}\r\n\r\n.page-header {\r\n  padding: 0;\r\n  position: relative;\r\n  overflow: hidden;\r\n  display: flex;\r\n  align-items: center;\r\n  background-size: cover;\r\n  background-position: 50%;\r\n  background: #000;\r\n  min-height: 100vh;\r\n}\r\n\r\n.card {\r\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);\r\n}\r\n.card-style{\r\nbackground: #292f36!important;\r\n}\r\n.card-descp{\r\ncolor: #fff;\r\n}\r\n\r\n.mt-xl-5 {\r\n  margin-top: 3rem !important;\r\n}\r\n\r\n.card .card-header {\r\n  padding: 1.5rem;\r\n  padding-bottom: 1.5rem;\r\n  border-bottom: 0px solid rgba(0, 0, 0, .125);\r\n\r\n}\r\n\r\n.card-header:first-child {\r\n  border-radius: 1rem 1rem 0 0;\r\n}\r\n\r\n.text-center {\r\n  text-align: center !important;\r\n}\r\n\r\n.bg-transparent {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.card .card-body {\r\n  font-family: 'Open Sans', sans-serif;\r\n  /* padding: 1.5rem; */\r\n}\r\n\r\n.card-body {\r\n  flex: 1 1 auto;\r\n  padding: 1rem 1rem;\r\n}\r\n\r\nlabel,\r\n.form-label {\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  margin-bottom: 0.5rem;\r\n  color: #252f40;\r\n  margin-left: 0.25rem;\r\n}\r\n\r\n.form-control {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 1rem 0.75rem;\r\n  font-size: 0.975rem;\r\n  font-weight: 400;\r\n  line-height: 1.4rem;\r\n  color: #333;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #d2d6da;\r\n  appearance: none;\r\n  border-radius: 0.2rem;\r\n  transition: box-shadow 0.15s ease, border-color 0.15s ease;\r\n}\r\n\r\n.form-switch {\r\n  padding-left: 3rem;\r\n}\r\n\r\n.form-check {\r\n  display: block;\r\n  min-height: 1.5rem;\r\n  padding-left: 1.73em;\r\n  margin-bottom: 0.125rem;\r\n}\r\n\r\n.form-switch .form-check-input:checked {\r\n  border-color: rgba(58, 65, 111, 0.95);\r\n  background-color: rgba(58, 65, 111, 0.95);\r\n}\r\n\r\n.form-switch .form-check-input:checked {\r\n  background-position: right center;\r\n  background-image: none;\r\n}\r\n\r\n.form-check-input:checked[type=\"checkbox\"] {\r\n  background-image: linear-gradient(310deg, #141727 0%, #3A416F 100%);\r\n}\r\n\r\n.form-switch .form-check-input {\r\n  border: 1px solid #e9ecef;\r\n  border-top-color: rgb(233, 236, 239);\r\n  border-right-color: rgb(233, 236, 239);\r\n  border-bottom-color: rgb(233, 236, 239);\r\n  border-left-color: rgb(233, 236, 239);\r\n  position: relative;\r\n  background-color: rgba(58, 65, 111, 0.1);\r\n  height: 1.25em;\r\n}\r\n\r\n.form-check-label,\r\n.form-check-input[type=\"checkbox\"] {\r\n  cursor: pointer;\r\n}\r\n\r\n.form-switch .form-check-input {\r\n  width: 2.5rem;\r\n  margin-left: -3rem;\r\n  background-image: none;\r\n  background-position: left center;\r\n  border-radius: 2.5rem;\r\n  transition: background-color 0.25s ease, border-color 0.25s ease, background-position 0.15s ease-in-out, opacity 0.15s ease-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n.form-check-input:checked {\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n}\r\n\r\n.form-check .form-check-input {\r\n  float: left;\r\n  margin-left: -1.73em;\r\n}\r\n\r\n.form-check-input {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n}\r\n\r\na {\r\n  letter-spacing: -0.025rem;\r\n  color: #000;\r\n}\r\n\r\n.form-check-input {\r\n  width: 1.23em;\r\n  height: 1.23em;\r\n  margin-top: 0.135em;\r\n  vertical-align: top;\r\n  background-color: #fff;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: contain;\r\n  border: none;\r\n  appearance: none;\r\n  color-adjust: exact;\r\n  transition: background-color 0.25s ease, border-color 0.25s ease, background-position 0.15s ease-in-out, opacity 0.15s ease-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n.form-check-input {\r\n  color-adjust: exact;\r\n}\r\n\r\n.form-switch .form-check-input:checked::after {\r\n  transform: translateX(21px);\r\n}\r\n\r\n.form-switch .form-check-input::after {\r\n  transition: transform 0.25s ease-in-out, background-color 0.25s ease-in-out;\r\n  content: \"\";\r\n  width: 1rem;\r\n  height: 1rem;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  background-color: #fff;\r\n  transform: translateX(1px);\r\n  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(20, 20, 20, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(20, 20, 20, 0.07);\r\n  top: 1px;\r\n}\r\n\r\n.text-bold {\r\n  font-weight: 600;\r\n}\r\n\r\n.text-decoration-none {\r\n  text-decoration: none !important;\r\n}\r\n\r\n.bg-primary {\r\n  background-color: #C22627 !important;\r\n}\r\n\r\n.me-xl-5 {\r\n  margin-right: 3rem !important;\r\n}\r\n\r\na:hover {\r\n  color: #830866;\r\n  text-decoration: none;\r\n}\r\n\r\n.me-xl-5 {\r\n  margin-right: 3rem !important;\r\n}\r\n\r\n.mb-sm-0 {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.container,\r\n.container-sm,\r\n.container-md,\r\n.container-lg,\r\n.container-xl,\r\n.container-xxl {\r\n  max-width: 1320px;\r\n}\r\n\r\n.nav-footer .nav-link {\r\n  font-size: .875rem;\r\n}\r\n\r\n.h2,\r\nh2 {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.btn-neutral {\r\n  color: #7b2fe3;\r\n}\r\n\r\n.table td,\r\n.table th {\r\n  font-size: .8125rem;\r\n  white-space: normal;\r\n}\r\n\r\n.pray_text {\r\n  max-width: 450px;\r\n}\r\n\r\n.table-flush tbody tr:first-child td,\r\n.table-flush tbody tr:first-child th {\r\n  border-top: 0;\r\n}\r\n\r\n.card .table td,\r\n.card .table th {\r\n  padding-right: 1rem;\r\n  padding-left: 1rem;\r\n}\r\n\r\n.custom-toggle {\r\n  position: relative;\r\n  display: inherit;\r\n  display: inline-block;\r\n  width: 52px;\r\n  height: 1.5rem;\r\n  margin: 0;\r\n}\r\n\r\n.custom-toggle input {\r\n  display: none;\r\n}\r\n\r\ninput[type=\"checkbox\"],\r\ninput[type=\"radio\"] {\r\n  box-sizing: border-box;\r\n  padding: 0;\r\n}\r\n\r\n.custom-toggle input:checked+.custom-toggle-slider {\r\n  border: 1px solid #7b2fe3;\r\n}\r\n\r\n.custom-toggle-slider {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  cursor: pointer;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 34px !important;\r\n  background-color: transparent;\r\n}\r\n\r\n.avatar.rounded-circle img,\r\n.rounded-circle {\r\n  border-radius: 50% !important;\r\n}\r\n\r\n.custom-toggle input:checked+.custom-toggle-slider::before {\r\n  transform: translateX(28px);\r\n  background: #7b2fe3;\r\n}\r\n\r\n.custom-toggle-slider::before {\r\n  position: absolute;\r\n  bottom: 2px;\r\n  left: 2px;\r\n  width: 18px;\r\n  height: 18px;\r\n  content: '';\r\n  transition: all .15s cubic-bezier(.68, -.55, .265, 1.55);\r\n  border-radius: 50% !important;\r\n  background-color: #e9ecef;\r\n}\r\n\r\n.custom-toggle input:checked+.custom-toggle-slider::after {\r\n  right: auto;\r\n  left: 0;\r\n  content: attr(data-label-on);\r\n  color: #7b2fe3;\r\n}\r\n\r\n.custom-toggle-slider::after {\r\n  font-family: inherit;\r\n  font-size: .75rem;\r\n  font-weight: 600;\r\n  line-height: 24px;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  display: block;\r\n  overflow: hidden;\r\n  min-width: 1.66667rem;\r\n  margin: 0 .21667rem;\r\n  content: attr(data-label-off);\r\n  transition: all .15s ease;\r\n  text-align: center;\r\n  color: #ced4da;\r\n}\r\n\r\n.form-control {\r\n  padding: .6rem .75rem !important;\r\n}\r\n\r\n.form-control-label {\r\n  font-size: .875rem;\r\n  font-weight: 600;\r\n  color: #2f3135;\r\n}\r\n\r\n.custom-file {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: calc(1.5em + 1.25rem + 2px);\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-file-input {\r\n  position: relative;\r\n  z-index: 2;\r\n  width: 100%;\r\n  height: calc(1.5em + 1.25rem + 2px);\r\n  margin: 0;\r\n  opacity: 0;\r\n}\r\n\r\n.custom-file-input {\r\n  width: 60% !important;\r\n  margin: 5px !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.custom-control-label::before,\r\n.custom-file-label,\r\n.custom-select {\r\n  transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n}\r\n\r\n.custom-file-label {\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  position: absolute;\r\n  z-index: 1;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  height: calc(1.5em + 1.25rem + 2px);\r\n  padding: .625rem .75rem;\r\n  color: #8898aa;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: .25rem;\r\n  background-color: #fff;\r\n  box-shadow: 0 3px 2px rgba(233, 236, 239, .05);\r\n}\r\n\r\n.custom-file-input:lang(en)~.custom-file-label::after {\r\n  content: 'Browse';\r\n}\r\n\r\n.custom-control-label::after {\r\n  top: 0.5rem !important;\r\n}\r\n\r\n.custom-file-label::after {\r\n  line-height: 1.5;\r\n  position: absolute;\r\n  z-index: 3;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  display: block;\r\n  height: calc(1.5em + 1.25rem);\r\n  padding: .625rem .75rem;\r\n  content: 'Browse';\r\n  color: #8898aa;\r\n  border-left: inherit;\r\n  border-radius: 0 .25rem .25rem 0;\r\n  background-color: #fff;\r\n}\r\n\r\n.pagination {\r\n  margin: 15px auto 10px;\r\n  padding-bottom: 2rem;\r\n  justify-content: end;\r\n}\r\n\r\n.card-header h3 {\r\n  font-size: 20px;\r\n}\r\n\r\n.pagination>.active>a {\r\n  background-color: #C22627;\r\n  border-color: #C22627;\r\n  color: #fff;\r\n}\r\n\r\n.pagination>li>a {\r\n  border: 1px solid #C22627;\r\n  padding: 5px 10px;\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.pagination>.active>a,\r\n.pagination>.active>span,\r\n.pagination>.active>a:hover,\r\n.pagination>.active>span:hover,\r\n.pagination>.active>a:focus,\r\n.pagination>.active>span:focus {\r\n  background-color: #C22627;\r\n  border-color: #C22627;\r\n  outline: none;\r\n}\r\n\r\n.pagination>li>a,\r\n.pagination>li>span {\r\n  color: #47ccde\r\n}\r\n\r\n.pagination>li:first-child>a,\r\n.pagination>li:first-child>span,\r\n.pagination>li:last-child>a,\r\n.pagination>li:last-child>span {\r\n  border-radius: unset\r\n}\r\n\r\n.svg-inline--fa.fa-play.fa-w-14 {\r\n  color: #04d611;\r\n}\r\n\r\n.loader_block {\r\n  position: fixed;\r\n  display: block;\r\n  left: 0%;\r\n  top: 0%;\r\n  width: 100%;\r\n  height: 100% !important;\r\n  z-index: 9999;\r\n  background-color: rgba(255, 255, 255, 0.7);\r\n}\r\n\r\n.loader_block span {\r\n  left: 50%;\r\n  top: 50%;\r\n  position: relative;\r\n}\r\n\r\n.hide-display {\r\n  display: none;\r\n}\r\n\r\n.Toastify__toast {\r\n  padding: 17px !important;\r\n}\r\n\r\n.doc_type {\r\n  font-size: large;\r\n  font-weight: bold;\r\n}\r\n\r\n.reject {\r\n  color: red;\r\n  font-weight: bold;\r\n}\r\n\r\n.approve {\r\n  color: green;\r\n  font-weight: bold;\r\n}\r\n\r\n.date-pickk {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.date-pickk input,\r\n.date-pickk>div {\r\n  width: 100% !important;\r\n}\r\n\r\n.date-pickk input {\r\n  color: #333;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #d2d6da;\r\n  appearance: none;\r\n  border-radius: 0.2rem;\r\n  padding: .6rem .75rem !important;\r\n}\r\n\r\n.display-end {\r\n  display: flex;\r\n  justify-content: end;\r\n}\r\n\r\n.contrcat-input {\r\n  width: 100%!important;\r\n  background: white!important;\r\n  border: 1px solid #d2d6da!important;\r\n  padding: .5rem .75rem!important;\r\n  border-radius: 3px!important;\r\n  font-size: 0.975rem!important;\r\n  font-weight: 400!important;\r\n  line-height: 1.4rem!important;\r\n  color: #333!important;\r\n}\r\n\r\n.paginate-css {\r\n  display: flex;\r\n  justify-content: end;\r\n}\r\n\r\n.pagination>.active>a {\r\n  background-color: #C22627;\r\n  border-color: #C22627;\r\n  color: #fff;\r\n}\r\n\r\n.pagination>li>a {\r\n  border: 1px solid #adb5bd;\r\n  padding: 8px 15px;\r\n  outline: none;\r\n  cursor: pointer;\r\n  margin: 3px;\r\n  text-transform: uppercase;\r\n  border-radius: 5px;\r\n}\r\n\r\n.pagination>.active>a,\r\n.pagination>.active>span,\r\n.pagination>.active>a:hover,\r\n.pagination>.active>span:hover,\r\n.pagination>.active>a:focus,\r\n.pagination>.active>span:focus {\r\n  background-color: #565b60;\r\n  border-color: #565b60;\r\n  outline: none;\r\n\r\n}\r\n\r\n.pagination>li>a,\r\n.pagination>li>span {\r\n  color: #565b60;\r\n}\r\n\r\n.pagination>li:first-child>a,\r\n.pagination>li:first-child>span,\r\n.pagination>li:last-child>a,\r\n.pagination>li:last-child>span {\r\n  border-radius: 2px\r\n}\r\n\r\n.table-user .name {\r\n  display: block;\r\n  max-width: 150px;\r\n  width: 100px;\r\n}\r\n\r\n.td-wrapper {\r\n  background-color: 'lightblue';\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.table-user .nameee {\r\n  display: block;\r\n  max-width: 150px;\r\n  width: 150px;\r\n\r\n}\r\n\r\n.table-user .name2 {\r\n  display: block;\r\n  max-width: 200px;\r\n  width: 170px;\r\n}\r\n\r\n.date {\r\n  width: 110px;\r\n  display: block;\r\n}\r\n\r\n.date2 {\r\n  width: 70px;\r\n  display: block;\r\n}\r\n\r\n.address {\r\n  display: block;\r\n  max-width: 200px;\r\n  width: 170px;\r\n}\r\n\r\n.name-letter {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 30px;\r\n  background-color: #C22627;\r\n  color: #fff;\r\n  justify-content: center;\r\n  align-items: center;\r\n  display: flex;\r\n  font-size: 20px;\r\n}\r\n\r\n.address-column {\r\n  width: 250px;\r\n  word-wrap: break-word;\r\n  /* background-color: #04d611; */\r\n}\r\n\r\n@media screen and (min-width: 1200px) {\r\n  .large-address-column {\r\n    width: 350px;\r\n    /* background-color: #6200ea; */\r\n  }\r\n}\r\n\r\n.mobile-sidebar-slide {\r\n  position: absolute;\r\n  top: 50px;\r\n  left: 0;\r\n  width: 250px;\r\n  height: 100vh;\r\n  background-color: #343a40; \r\n  z-index: 1000;\r\n  animation: slideInLeft 0.3s ease forwards;\r\n  color: white;\r\n  padding: 1rem;\r\n}\r\n\r\n@keyframes slideInLeft {\r\n  0% {\r\n    transform: translateX(-100%);\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n\r\n.navbar-nav ul {\r\n  list-style: none;\r\n  padding-left: 0.5rem;\r\n}\r\n.navbar-nav .nav-item .nav-link.active {\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n.no-scrollbar {\r\n  overflow-y: scroll;\r\n}\r\n\r\n/* Chrome, Edge, Safari */\r\n.no-scrollbar::-webkit-scrollbar {\r\n  width: 4px;          /* decrease width */\r\n}\r\n\r\n.no-scrollbar::-webkit-scrollbar-track {\r\n  background: #f1f1f1; /* track color (optional) */\r\n}\r\n\r\n.no-scrollbar::-webkit-scrollbar-thumb {\r\n  background: #888;    /* thumb color */\r\n  border-radius: 10px;\r\n}\r\n\r\n.no-scrollbar::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n/* Firefox */\r\n.no-scrollbar {\r\n  scrollbar-width: thin;  /* makes it thin */\r\n  scrollbar-color: #888 #f1f1f1; /* thumb + track colors */\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
